/* Clear only legacy declaration attributes on explicit native cart checkout.
 * No background request, agreement, validation gate or navigation.
 */
(() => {
  'use strict';
  if (window.mmCartLegacyAttributesInitialized) return;
  window.mmCartLegacyAttributesInitialized = true;
  const legacyKeys = [
    'Digitalinhalt Sofortbeginn',
    'Digitalinhalt Zustimmung Zeitpunkt',
    'Digitalinhalt Zustimmung Wortlautversion',
    'Digitalinhalt Zustimmung Geltungsbereich',
    'Digitalinhalt Zustimmung Text',
    'Digitalinhalt Zustimmung Quelle',
  ];

  function prepareNativeCheckout(form) {
    if (!(form instanceof HTMLFormElement) || form.method.toLowerCase() !== 'post') return;
    let action;
    try { action = new URL(form.action, document.baseURI); } catch (_) { return; }
    if (action.origin !== window.location.origin || !action.pathname.endsWith('/cart')) return;

    const controls = Array.from(form.elements);
    legacyKeys.forEach(key => {
      const name = `attributes[${key}]`;
      const existing = controls.filter(control => control.name === name && 'value' in control);
      existing.forEach(control => { control.value = ''; });
      // form.elements includes fields associated from outside the form.
      // Disabled stale fields must not suppress a successful blank clearing field.
      if (existing.some(control => control instanceof HTMLInputElement && control.type === 'hidden' && !control.disabled)) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = '';
      form.appendChild(input);
    });
  }

  document.addEventListener('click', event => {
    const button = event.target instanceof Element
      ? event.target.closest('button[name="checkout"], input[name="checkout"]') : null;
    if (button && !button.disabled) prepareNativeCheckout(button.form);
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter?.name === 'checkout') prepareNativeCheckout(event.target);
  }, true);
})();
